// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__oD6rt","Link":"StickyAlert_Link__+OrNw","CloseButton":"StickyAlert_CloseButton__L0DIG"};